
import styles from "../addtuyaaccount.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, FormControl, InputLabel, MenuItem, Select, Tooltip } from "@mui/material";
import { useState } from "react";
import { Calendar, Search, X } from "react-feather";
import dayjs from "dayjs";
import DateRangePicker from "rsuite/DateRangePicker";
import { useEffect } from "react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { TableLoader } from "../../../../../components/LoaderC";

const Step2 = ({ onSubmitLocal, tuyaData, setStep }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [contentLoading, setContentLoading] = useState(true);
    const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [allTuyaDeviceList, setAllTuyaDeviceList] = useState([]);
    const [tuyaDeviceList, setTuyaDeviceList] = useState([]);
    const [deviceList, setDeviceList] = useState([]);
    const [defaultDateFilter, setDefaultDateFilter] = useState(null);
    const [filterObj, setFilterObj] = useState({ type: '', status: '' });
    const [searchKey, setSearchKey] = useState("");
    const [deviceIds, setDeviceIds] = useState([]);

    useEffect(() => {
        const fetchDeviceList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/all-iot-devices", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: tuyaData
            }).then((response) => {
                setContentLoading(false);
                setAllTuyaDeviceList(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };

        if (tuyaData)
            fetchDeviceList();
    }, [getAccessTokenSilently, tuyaData]);

    useEffect(() => {
        const fetchDeviceIdList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/device-ids/" + tuyaData?.project_id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setDeviceIds(response.data.data);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };

        if (tuyaData?.project_id)
            fetchDeviceIdList();
    }, [getAccessTokenSilently, tuyaData?.project_id]);

    useEffect(() => {
        if (allTuyaDeviceList.length) {
            let tempDeviceList = allTuyaDeviceList.filter(i => deviceIds.indexOf(i.id) === -1);
            tempDeviceList.sort((a, b) => a.active_time < b.active_time ? 1 : -1)

            setTuyaDeviceList(tempDeviceList);
        }
    }, [deviceIds, allTuyaDeviceList]);

    useEffect(() => {
        if (tuyaDeviceList.length) {
            let tempDeviceList = tuyaDeviceList;

            if (searchKey !== '') {
                let inputVal = searchKey;
                inputVal = inputVal.toLowerCase();

                tempDeviceList = tempDeviceList.filter((item) => {
                    return (item?.id?.toLowerCase().includes(inputVal) || item?.name?.toLowerCase().includes(inputVal) || item?.product_name?.toLowerCase().includes(inputVal));
                });
            }

            if (defaultDateFilter) {
                tempDeviceList = tempDeviceList.filter(i => {
                    if (dayjs(dayjs.unix(i?.active_time).format("YYYY-MM-DD")).isBetween(dayjs(defaultDateFilter[0]).format("YYYY-MM-DD"), dayjs(defaultDateFilter[1]).format("YYYY-MM-DD"), undefined, [])) {
                        return true;
                    }
                    return false;
                })
            }

            if (filterObj?.type !== '' && filterObj?.type !== 'all') {
                tempDeviceList = tempDeviceList.filter((i) => i.product_name === filterObj.type);
            }

            if (filterObj?.status !== '' && filterObj?.status !== 'all') {
                if (filterObj?.status === 'online') {
                    tempDeviceList = tempDeviceList.filter((i) => i.online);
                }
                if (filterObj?.status === 'offline') {
                    tempDeviceList = tempDeviceList.filter((i) => !i.online);
                }
            }

            setDeviceList(tempDeviceList);
        }
    }, [tuyaDeviceList, defaultDateFilter, searchKey, filterObj]);

    const onSubmit = () => {
        onSubmitLocal(selectedDevices);
    }

    const getLocationVal = (id) => {
        if (selectedDeviceIds.indexOf(id) > -1) {
            let deviceTemp = selectedDevices?.filter(i => i?.id === id);
            if (deviceTemp?.length > 0) {
                return deviceTemp[0]?.location;
            }
        }
        return '';
    }

    return (<div className={`${styles.ModalFormGroup}`}>
        <div className={`${styles.AddDeviceSec}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setSearchKey(e.target.value)} />
            </div>
            <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} FormGroup AddDevice`}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Device Type</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Device Type"
                        value={filterObj?.type}
                        onChange={(e) => {
                            setFilterObj((prev) => {
                                return { ...prev, type: e.target.value };
                            });
                        }}
                    >
                        <MenuItem value={'all'}>All</MenuItem>
                        <MenuItem value={'Smart Dimmer Switch'}>Smart Dimmer Switch</MenuItem>
                        <MenuItem value={'Thermostat'}>Thermostat</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width150} FormGroup AddDevice`}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Status</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Status"
                        value={filterObj?.status}
                        onChange={(e) => {
                            setFilterObj((prev) => {
                                return { ...prev, status: e.target.value };
                            });
                        }}
                    >
                        <MenuItem value={'all'}>All</MenuItem>
                        <MenuItem value={'online'}>Online</MenuItem>
                        <MenuItem value={'offline'}>Offline</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className={`${styles.AddDeviceDatePick} DashFilterSec AddDevice`}>
                <DateRangePicker
                    format={"M/d/yy"}
                    placeholder={"Filter by date"}
                    placement={"bottomEnd"}
                    caretAs={Calendar}
                    showOneCalendar
                    onChange={(e) => setDefaultDateFilter(e)}
                />
            </div>
        </div>
        <p className={`${styles.DeviceSelectedMSG}`}>{(selectedDeviceIds?.length > 0 ? (selectedDeviceIds?.length > 1 ? selectedDeviceIds?.length + ' devices selected' : selectedDeviceIds?.length + ' device selected') : 'No device selected')}</p>

        {contentLoading && <div className="Loader TableLoader">
            <TableLoader />
        </div>}


        {!contentLoading && <div className={`${styles.AddDeviceRow}`}>
            {deviceList?.map((item, index) => {
                return (<div className={`${styles.AddDeviceList}`} key={index}>
                    <div className={selectedDeviceIds.indexOf(item?.id) > -1 ? `${styles.AddDeviceListUnder} ${styles.Active}` : `${styles.AddDeviceListUnder}`}>
                        <div className={`${styles.AddDeviceListHeadSec}`}>
                            <div className={`${styles.AddDeviceListIconSec}`}>
                                {(item?.product_name === 'Smart Dimmer Switch' ? <img src="/static/img/bulb.svg" width="24px" height="24px" alt="" /> : (item?.product_name === 'Thermostat' ? <img src="/static/img/temperature.svg" width="24px" height="24px" alt="" /> : <img src="/static/img/smart-device-default.svg" width="24px" height="24px" alt="" />))}
                            </div>
                            <div className={`${styles.AddDeviceListTitleSec}`}>
                                <p className={`${styles.AddDeviceListTitle}`}>
                                    <Tooltip title={item.name} placement="bottom-start">{item?.name}</Tooltip>
                                    {item?.online && <span className={`${styles.OpenBadge}`}>Online</span>}
                                    {!item?.online && <span className={`${styles.OfflineBadge}`}>Offline</span>}
                                </p>
                                <p className={`${styles.AddDeviceListTitle}`}><Tooltip title={item?.product_name} placement="bottom-start">{item?.product_name}</Tooltip></p>
                            </div>
                        </div>
                        <div className={`${styles.ProspectCardFootSec}`}>
                            <p className={`${styles.ProsCardDate}`}>{dayjs.unix(item?.active_time).fromNow()}</p>
                            <div className={selectedDeviceIds.indexOf(item?.id) > -1 ? `${styles.MainReqConDropBU} FormGroup SelectRoom Active` : `${styles.MainReqConDropBU} FormGroup SelectRoom`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select Room</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Select Room"
                                        value={getLocationVal(item?.id)}
                                        onChange={(e) => {
                                            if (selectedDeviceIds.indexOf(item?.id) === -1) {
                                                setSelectedDeviceIds(prev => {
                                                    return prev.concat([item?.id]);
                                                });
                                                setSelectedDevices(prev => {
                                                    return prev.concat([{ id: item?.id, name: item?.name, online: item?.online, location: e.target.value, product_name: item?.product_name }]);
                                                });
                                            } else {
                                                setSelectedDevices(prev => {
                                                    return prev.map(i => {
                                                        if (i?.id === item?.id)
                                                            return { ...i, location: e.target.value };
                                                        return i;
                                                    });
                                                });
                                            }
                                        }}
                                    >
                                        <MenuItem value={'Bedroom'}>Bedroom</MenuItem>
                                        <MenuItem value={'Bedroom Closet'}>Bedroom Closet</MenuItem>
                                        <MenuItem value={'Bathroom'}>Bathroom</MenuItem>
                                        <MenuItem value={'Living Room'}>Living Room</MenuItem>
                                        <MenuItem value={'Living Room Closet'}>Living Room Closet</MenuItem>
                                    </Select>
                                </FormControl>
                                <button className={`${styles.ResetRoomSelect}`} type="button" onClick={(e) => {
                                    setSelectedDeviceIds(prev => {
                                        return prev.filter(i => i !== item?.id);
                                    });
                                    setSelectedDevices(prev => {
                                        return prev.filter(i => i?.id !== item?.id);
                                    });
                                }}><X /></button>
                            </div>
                        </div>
                    </div>
                </div>);
            })}
        </div>}
        <div className={`${styles.ButtonAction}`}>
            <Button className="CancelPopupBU" onClick={(e) => setStep(1)}>Back</Button>
            <Button className="SubmitPopupBU" onClick={(e) => { onSubmit(); }}>Add</Button>
        </div>
    </div>);
};

export default Step2;